import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../context/WithConsumer';


export default class ModTeam extends Component {
    render () {
	    let block 	= this.props.block;
	    let team = block.team.map(function(team,i){
		    return <div className="c-team__block" key={i}>
		    	<div className="c-team__block__image">
					<FadeIn duration={250}>
						{onload => (
							<img
								src={team.headshot_src} 
								srcSet={team.headshot_srcset} 
								onLoad={onload}
							/>
						)}
					</FadeIn>
					{team.profile &&
						<div className="c-team__block__profile">
							<div className="scope-text scope-text--small" dangerouslySetInnerHTML={ {__html: team.profile } }></div>
						</div>
					}
				</div>
				<h4 className="c-team__block__name">{ team.name }</h4>
				<h5 className="c-team__block__role">{ team.role }</h5>
				
			</div>
		});
	    return (
	        <div className={'l-block l-block--display-' + block.display + ' scope-' + block.text_color + ' scope-' + block.image_effect} style={{backgroundColor: block.block_color}}>
	        	<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
		        	<div className="l-grid">
			        	<div className="l-grid__col">
				        	{block.heading &&
					        	<h1 className="c-heading c-heading--large c-heading--large-space">{ block.heading }</h1>
				        	}
			        	</div>
			        	<div className="l-grid__col">
				        	<div className="c-team">
								{ team }
				        	</div>
			        	</div>
			        </div>
				</ScrollAnimation>
			</div>
		)
	};

};
